import { currency } from "./currency/currency";

/* eslint-disable no-bitwise */
export function capitalize(str = "") {
  let newStr = [];
  if (str.includes("-")) newStr = str.split("-");
  else if (str.includes("_")) newStr = str.split("_");
  else newStr = str.split(" ");
  return newStr
    .map((word) => {
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(" ");
}

export function uuidV4() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export const uniqueArrayOfObject = (array, keyToBeUnique) => {
  // Filter by looking at the next objects if the key is present a second time
  return array?.filter((x, xi) => {
    return !array.slice(xi + 1).some((y) => {
      return y[keyToBeUnique] === x[keyToBeUnique];
    });
  });
};

export const isNullOrEmptyOrUndefined = (value) => {
  if (typeof value === "string") {
    value = value.trim(); // Remove leading and trailing spaces
  }
  return [null, "", undefined].includes(value);
};

export const roundUpCurrency = (value, precision = 0) => {
  return currency(value, { precision }).format();
};